"use client";

import { c as _c } from "react/compiler-runtime";
import type { SupportedChain } from "@/components/nft-picker/NftPicker.types";
import type { TokenPanelState } from "../types";
import { GrantTokensDisclosure } from "./GrantTokensDisclosure";
interface GrantTokensPanelProps {
  readonly chain: SupportedChain | null;
  readonly contractAddress: `0x${string}` | null;
  readonly grantId: string;
  readonly state: TokenPanelState;
}
export function GrantTokensPanel(t0) {
  const $ = _c(7);
  const {
    chain,
    contractAddress,
    grantId,
    state
  } = t0;
  if (state.type === "all") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="tw-mt-4 tw-rounded-lg tw-border tw-border-iron-800 tw-bg-iron-950 tw-p-3"><p className="tw-m-0 tw-text-sm tw-text-iron-200">This grant applies to every token in the collection.</p></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const tokensCount = state.type === "count" ? state.count : null;
  let t1;
  if ($[1] !== chain || $[2] !== contractAddress || $[3] !== grantId || $[4] !== state.label || $[5] !== tokensCount) {
    t1 = <GrantTokensDisclosure chain={chain} contractAddress={contractAddress} grantId={grantId} tokensCount={tokensCount} tokensCountLabel={state.label} />;
    $[1] = chain;
    $[2] = contractAddress;
    $[3] = grantId;
    $[4] = state.label;
    $[5] = tokensCount;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}